<script lang="ts" setup>
import LeftSideBar from "@/components/layouts/leftSideBar/index.vue";
import TopBar from "@/components/layouts/topBar/index.vue";
import { useLayoutStore } from "@/store/app";
import { computed } from "vue";
import { LAYOUTS } from "@/app/const";
const state = useLayoutStore();

const isHorizontal = computed(() => {
  return state.layoutType === LAYOUTS.HORIZONTAL;
});
</script>
<template>
  <div>
    <v-layout
      class="main-layout-wrapper justify-center position-relative"
      id="layout-wrapper"
    >
      <LeftSideBar />
      <TopBar />
      <v-main app>
        <v-container
          :class="!isHorizontal ? 'pt-0' : ''"
          :fluid="!isHorizontal"
          class="main-container"
        >
          <router-view />
        </v-container>
      </v-main>
      
    </v-layout>
  </div>
</template>
